import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { StorageService } from '../../services/storage/storage.service';
import { PredefinedTemplatesService } from '../../services/edit/predefined-templates.service';
import { SharedService } from './../../services/shared/shared.service';
import { ConfigService } from '../../services/config/config.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'ag-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() footer: any;

  private _lid: any;
  private _cid: any;
  private _destroyed$ = new Subject<void>();

  constructor(
    public configService: ConfigService,
    private _predefinedTemplatesService: PredefinedTemplatesService,
    private _sharedService: SharedService,
    private _storageService: StorageService,
  ) {}

  ngOnInit() {
    this._sharedService
      .getLibraryChangedBS()
      .pipe(takeUntil(this._destroyed$))
      .subscribe((values) => {
        if (!values) {
          return;
        }

        this._cid = values.cid;
        this._lid = values.lid;

        this._getFooter(this._cid, this._lid);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.footer = changes.footer.currentValue;
  }

  ngAfterViewInit(): void {
    this._predefinedTemplatesService
      .getFooterUndefinedBS()
      .pipe(takeUntil(this._destroyed$))
      .subscribe((response) => {
        if (response !== null && response) {
          this.footer = undefined;
        }
      });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  private async _getFooter(cid, lid) {
    this._predefinedTemplatesService.getFooter(cid, lid).subscribe((response) => {
      this._storageService.setFetchExpressFooter('N');
      if (response && response.status == '200 OK' && response.message == 'Success') {
        if (response.data.length > 0) {
          this.footer = response.data[0];
        } else {
          this.footer = undefined;
        }
      } else {
        this.footer = undefined;
      }
    });
  }
}
